import { CircleNotch } from "@phosphor-icons/react";

// Neutral loading state shown while a lazily-loaded route chunk downloads.
// Kept minimal so it never shifts the layout of the eventual content.
export default function RouteFallback() {
  return (
    <div className="w-full flex items-center justify-center py-24" data-testid="route-fallback" aria-busy="true">
      <CircleNotch size={28} className="animate-spin text-[#3BB54A]" />
    </div>
  );
}
